import React from 'react'

import { SurveysContextController } from 'context/surveys/surveysContextController/SurveysContextController'
import { TourContextController } from 'context/tour/tourContextController/TourContextController'
import { PulseSurveysContextController } from 'context/pulseSurveys/pulseSurveysContextController/PulseSurveysContextController'

import { DashboardProvidersProps } from './DashboardProviders.types'

export const DashboardProviders = ({ children }: DashboardProvidersProps) => (
    <TourContextController>
        <SurveysContextController>
            <PulseSurveysContextController>{children}</PulseSurveysContextController>
        </SurveysContextController>
    </TourContextController>
)
